import React from 'react'
import PropTypes from 'prop-types'
import Title from '../shared/Title'
import { FormattedMessage } from 'react-intl'
import styles from './_worksWith.css'
import appleWatch from 'images/app-page/works-with/devices/apple-watch.png'
import samsungGear from 'images/app-page/works-with/devices/samsung-gear.png'
import fitbit from 'images/app-page/works-with/logos/logo-fitbit.png'
import garmin from 'images/app-page/works-with/logos/logo-garmin.png'
import polar from 'images/app-page/works-with/logos/logo-polar.png'
import suunto from 'images/app-page/works-with/logos/logo-suunto.png'

function WorksWith () {
  return (
    <div className={styles.worksWith}>
      <div className={styles.favoriteDevices}>
        <div className={styles.favoriteDevicesContent}>
          <Title align='center'>
            <FormattedMessage id='appPage.worksWith.title' defaultMessage='Works With Your Favorite Devices' />
          </Title>
          <div className={styles.favorites}>
            <p className={styles.favorite}>
              <FormattedMessage id='appPage.worksWith.appleWatch' defaultMessage='Apple Watch' />
            </p>
            <p className={styles.favorite}>
              <FormattedMessage id='appPage.worksWith.samsungGear' defaultMessage={'Samsung Gear'} />
            </p>
          </div>
        </div>
        <div className={styles.appleWatch}>
          <img src={appleWatch} />
          <p className={styles.deviceCaption}>
            <FormattedMessage id='appPage.worksWith.appleWatch' defaultMessage='Apple Watch' />
          </p>
        </div>
        <div className={styles.samsungGear}>
          <img src={samsungGear} />
          <p className={styles.deviceCaption}>
            <FormattedMessage id='appPage.worksWith.samsungGear' defaultMessage={'Samsung Gear'} />
          </p>
        </div>
      </div>
      <div className={styles.alsoWorksWith}>
        <h3>Also Works With</h3>
        <ul className={styles.logos}>
          <Logo src={garmin} alt="Garmin" />
          <Logo src={suunto} alt="Suunto" />
          <Logo src={polar} alt="Polar" />
          <Logo src={fitbit} alt="Fitbit" />
        </ul>
      </div>
    </div>
  )
}

function Logo (props) {
  const { src, alt } = props
  return (
    <li className={styles.logo}>
      <img src={src} alt={alt} />
    </li>
  )
}

Logo.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
}

export default WorksWith
